import ChartCampagne from "../../campagnes/components/chart-campagne";

export default function DashboardConversation() {
  return (
    <div className="xl:px-4 py-4">
      <ChartCampagne />{" "}
    </div>
  );
}
